/**
 * Main modal header component.
 * Renders the modal header with close button and assistance request button.
 * @returns {JSX.Element}
 */
export default function ModalHeader() {
  return (
    <div className="shortwaysDrag modal-header">
      <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" data-form-type="other" />
      <button type="button" id="mainPopupRequestFile" className="btn requestAssistance" title="Send assistance request email" data-form-type="action" data-testid="mainPopupRequestFile" />
    </div>
  )
}
